/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiConfigsGetTargeting } from "../../funcs/aiConfigsGetTargeting.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAIConfigTargetingRequest$inboundSchema,
};

export const tool$aiConfigsGetTargeting: ToolDefinition<typeof args> = {
  name: "get-ai-config-targeting",
  description:
    `Retrieves the targeting details of a specific AI Config, including individual targets, rules, and rollouts.`,
  scopes: ["read"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await aiConfigsGetTargeting(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
